const FOCUSABLE_ELEMENT_SELECTOR = [
  'a[href]',
  'area[href]',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'button:not([disabled])',
  'iframe',
  '[tabindex]',
  '[contentEditable=true]',
]
  .map(element => `${element}:not([tabindex^="-"])`)
  .join(', ');

export const getFocusableChildren = element => {
  if (!element) return {};

  const elements = Array.from(element.querySelectorAll(FOCUSABLE_ELEMENT_SELECTOR));
  const priorityElements = elements.filter(el => el.tabIndex > 0).sort((a, b) => b.tabIndex - a.tabIndex);
  const restElements = elements.filter(el => !el.tabIndex);
  const sortedElements = [...priorityElements, ...restElements];

  if (sortedElements.length) {
    return {
      all: sortedElements,
      first: sortedElements[0],
      last: sortedElements[sortedElements.length - 1],
    };
  }

  return {};
};
